<template>
    <div class="error-container">
        <img
            class="error-image"
            src="/storage/assets/images/errors/404.png"
            alt="404"
        />

        <primary-button @click="redirect()">
            {{ $translate('errors.404.button') }}
        </primary-button>
    </div>
</template>
<script setup>
import { useAuthStore } from '@/js/stores/authStore';
import { useHead } from '@unhead/vue';
import { useRouter } from 'vue-router';

const $router = useRouter();
const authStore = useAuthStore();

useHead({
    title: '404 - Page not found',
    meta: [
        {
            name: 'prerender-status-code',
            content: '404',
        },
    ],
});

const redirect = () => {
    if (authStore.$state.isAuth) {
        $router.push({
            name: 'dashboard',
            params: {
                lang: 'fr',
            },
        });
    } else {
        $router.push({
            name: 'home',
            params: {
                lang: 'fr',
            },
        });
    }
};
</script>

<style lang="scss" scoped>
.error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
}
.error-image {
    width: 50%;
}
</style>
